<div class="modal-container" *ngIf="data$ | async as data">
  <!-- Icon Section -->
  <div class="icon-section">
    <app-pencil-icon name="rocket-stars" [type]="IconTypes.svgIcon"></app-pencil-icon>
  </div>

  <!-- Content Section -->
  <div class="content-section">
    <h2 class="modal-title">
      {{ 'Welcome to {{planName}}!' | translate: {planName: data.planName} }}
    </h2>
    <p class="modal-description">
      {{
        'Start exploring Pencil Spaces, or read a quick guide to get the most out of your plan.'
          | translate
      }}
    </p>
  </div>

  <!-- Buttons Section -->
  <div class="action-buttons-section">
    <app-pencil-button
      class="view-guide-btn"
      [theme]="PencilButtonThemeEnum.SECONDARY"
      [label]="'View guide' | translate"
      icon="open_in_new"
      [iconConfig]="{ type: IconTypes.materialIcon }"
      buttonType="button"
      (clickEvent)="viewGuide()"
      data-name="institutional-plan-upgrade-success-modal-view-guide"
    ></app-pencil-button>
    <app-pencil-button
      class="start-exploring-btn"
      [theme]="PencilButtonThemeEnum.PRIMARY"
      [label]="'Start exploring' | translate"
      icon="arrow_forward"
      [iconConfig]="{ type: IconTypes.materialIcon }"
      buttonType="button"
      (clickEvent)="close()"
      data-name="institutional-plan-upgrade-success-modal-start-exploring"
    ></app-pencil-button>
  </div>
</div>
